<app-contract-add
  [partnerObject]="partnerObject"
  [ofwcaObject]="ofwcaObject"
  [selfBillingFormObject]="selfBillingFormObject"
  (contractCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
></app-contract-add>
